import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DropDownOption } from '../drop-down/drop-down.component';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';


@Component({
  selector: 'kion-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, OnChanges{

  constructor(
    private translateService: TranslateService,
    private router: Router
  ) { }

  // per page is default an array with options: 10/20/50/100
  // default 20 is selected always
  @Input() perPage: DropDownOption[];
  @Input() totalPages = 10;
  @Input() currentPage = 3;
  @Input() defaultPerPageSelected: 10 | 20 | 50 | 100 | number = 20;
  @Input() currentPerPage: number;
  @Input() isLink: boolean;

  // tslint:disable-next-line:no-output-rename
  @Output('perPageChanged') perPageChangedEmitter: EventEmitter<number> = new EventEmitter<number>();
  // tslint:disable-next-line:no-output-rename
  @Output('pageChanged') pageChangedEmitter: EventEmitter<number> = new EventEmitter<number>();

  private lookAround = 2;

  get showFirstPage(): boolean {
    return this.currentPage - this.lookAround > 1;
  }

  get showFirstPageEllipsis(): boolean {
    return this.currentPage - this.lookAround > 2;
  }

  get showLastPage(): boolean {
    return this.currentPage + this.lookAround < this.totalPages;
  }

  get showLastPageEllipsis() : boolean {
    return this.currentPage + this.lookAround + 1 < this.totalPages;
  }

  get canGotoPrevious(): boolean {
    return this.currentPage > 1;
  }

  get canGotoNext(): boolean {
    return this.currentPage < this.totalPages;
  }

  get pages(): number[] {
    const result: number[] = [];
    const from = Math.max(1, this.currentPage - this.lookAround);
    const to = Math.min(this.totalPages, this.currentPage + this.lookAround);
    for(let i = from; i <= to; ++i) {
      result.push(i);
    }

    return result;
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.perPage = [
        this.createPerPageOption(10, this.defaultPerPageSelected),
        this.createPerPageOption(20, this.defaultPerPageSelected),
        this.createPerPageOption(50, this.defaultPerPageSelected),
        this.createPerPageOption(100, this.defaultPerPageSelected)
      ];
    }, 500)
  }

  private createPerPageOption(perPage: number, defaultPerPage: number) {
    return {
      key: perPage,
      value: perPage.toString() + ' ' + this.translateService.instant('pagination.dropDown.title'),
      selected: defaultPerPage == perPage ? true : false
    }
  }

  gotoPrevious(): void {
    if (this.canGotoPrevious) {
      this.goto(this.currentPage - 1);
    }
  }

  gotoNext(): void {
    if (this.canGotoNext) {
      this.goto(this.currentPage + 1);
    }
  }

  goto(page : number): void {
    this.currentPage = page;
    this.pageChangedEmitter.emit(page);
  }

  getGoToLink(page: number): string {
    this.currentPage = page;
    this.pageChangedEmitter.emit(page);
    const urlTree = this.router.parseUrl(this.router.url);
    urlTree.queryParams = {};
    return urlTree.toString();
  }

  getQueryParams(page: number): any {
    const urlTree = this.router.parseUrl(this.router.url);
    urlTree.queryParams.perPage = this.perPage.find(option => option.selected)?.key;
    urlTree.queryParams.page = page;
    return urlTree.queryParams;
  }

  dropDownOptionSelected(option: DropDownOption): void {
    this.perPageChangedEmitter.emit(option.key);
    this.perPage = this.perPage.map(
      (localOption: DropDownOption) => {
        return {
          ...localOption,
          selected: option.key === localOption.key
        }
      }
    )
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentPerPage) {
      this.perPage = this.perPage?.map(
        option => {
          return {
            ...option,
            selected: option.key === changes.currentPerPage.currentValue
          }
        }
      )
    }
  }
}
